import { heroModes } from "@/mocks/comicGuide";

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] md:h-[600px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20manga%20comic%20illustration%2C%20warm%20orange%20and%20deep%20red%20palette%2C%20dynamic%20speed%20lines%20and%20action%20bursts%2C%20young%20people%20reading%20comics%20on%20sofa%20and%20tablet%2C%20floating%20speech%20bubbles%2C%20halftone%20dot%20texture%2C%20bold%20graphic%20novel%20style%2C%20minimal%20clean%20background%2C%20high%20contrast%2C%20no%20text&width=1600&height=900&seq=hero-comic-guide-2026&orientation=landscape"
          alt="66漫画网阅读方式展示，下拉翻页目录全屏四种模式"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 md:px-6 py-16 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-book-open-line text-sm"></i>
          顺畅阅读 · 模式自由切换
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-background-50">
          66漫画网 <span className="text-accent-400">怎么读</span>？
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-background-100/95">
          下拉、翻页、目录跳转、全屏模式，总能找到适合你的节奏。
          第一次来不知道怎么读？页面内的阅读设置清晰易懂，按提示选好模式，
          就能顺畅看完全篇，体验不卡壳。
        </p>

        <div className="mx-auto mt-8 flex max-w-2xl flex-wrap items-center justify-center gap-3">
          {heroModes.map((m) => (
            <span
              key={m.label}
              className="inline-flex items-center gap-2 rounded-full bg-background-50/15 border border-background-50/30 px-4 py-2 text-sm text-background-50 backdrop-blur"
            >
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              {m.label}
            </span>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#guide"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            新手阅读设置指南
            <i className="ri-arrow-down-line text-lg"></i>
          </a>
          <a
            href="#modes"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 bg-background-50/10 px-7 py-3 text-base text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            了解四种阅读方式
          </a>
        </div>
      </div>
    </section>
  );
}